"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomWindowVariableKey = void 0;
const env_1 = require("./env");
exports.randomWindowVariableKey = '__frontend_utils_consistent_random';
function getConsistentRandomNumber() {
    if (!(0, env_1.isOnBrowser)()) {
        return 0; // zero will never sample in
    }
    if (window[exports.randomWindowVariableKey]) {
        return window[exports.randomWindowVariableKey];
    }
    window[exports.randomWindowVariableKey] = Math.random();
    return window[exports.randomWindowVariableKey];
}
exports.default = getConsistentRandomNumber;
